import { render, staticRenderFns } from "./jobLiu.vue?vue&type=template&id=8107b67c"
import script from "./jobLiu.vue?vue&type=script&lang=js"
export * from "./jobLiu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports